import { render, staticRenderFns } from "./SwitchAccount.vue?vue&type=template&id=c3dad95c&scoped=true"
import script from "./SwitchAccount.vue?vue&type=script&lang=js"
export * from "./SwitchAccount.vue?vue&type=script&lang=js"
import style0 from "./SwitchAccount.vue?vue&type=style&index=0&id=c3dad95c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dad95c",
  null
  
)

export default component.exports